import script from "./SearchResultsPane.vue?vue&type=script&lang=ts&setup=true"
export * from "./SearchResultsPane.vue?vue&type=script&lang=ts&setup=true"

import "./SearchResultsPane.vue?vue&type=style&index=0&id=68276a46&lang=scss"

const __exports__ = script;

export default __exports__